function reviewsinitializeSwiper() {
  var swiper = new Swiper(".cstm-services", {
    slidesPerView: 4,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      348: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 4,
      },
    }
  });
}
reviewsinitializeSwiper();